import {
  BadgeCheck,
  Ban,
  Bike,
  CircleAlert,
  DoorOpen,
  Hourglass,
  Inbox,
  PackageCheck,
  ShoppingBag,
  Store,
  type LucideIcon,
} from 'lucide-react';

import type { DeliveryStatus } from '@/api/types';
import { statusLabel, statusTone } from '@/lib/status';
import { Badge } from './ui/badge';

/**
 * Where a delivery has got to, in one pill.
 *
 * Icon AND colour AND words, every time. Any two of the three can fail a
 * reader — colour to colour-blindness and to sunlight, the icon to a small
 * screen — and the words are what survive both.
 */
const ICONS: Record<DeliveryStatus, LucideIcon> = {
  PENDING: Hourglass,
  ASSIGNED: Inbox,
  ACCEPTED: Bike,
  ARRIVED_AT_PHARMACY: Store,
  PICKED_UP: ShoppingBag,
  OUT_FOR_DELIVERY: Bike,
  ARRIVED_AT_CUSTOMER: DoorOpen,
  DELIVERED: BadgeCheck,
  FAILED: CircleAlert,
  CANCELLED: Ban,
};

export function StatusPill({
  status,
  size = 'sm',
  className,
}: {
  status: DeliveryStatus;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <Badge tone={statusTone(status)} size={size} icon={ICONS[status] ?? PackageCheck} className={className}>
      {statusLabel(status)}
    </Badge>
  );
}
